/*
 * Setter declarations
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-11 16:13:10
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
/** 字段选项卡 */
export var TAB_BAR;
(function (TAB_BAR) {
    /** 全部字段 */
    TAB_BAR["ALL"] = "all";
    /** 普通字段 */
    TAB_BAR["NORMAL"] = "normal";
    /** 列表字段 */
    TAB_BAR["TABLE"] = "table";
})(TAB_BAR || (TAB_BAR = {}));
export var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE[FIELD_TYPE["DEFAULT"] = 0] = "DEFAULT";
    /** 通用文本 1 */
    FIELD_TYPE[FIELD_TYPE["COMMON_TEXT"] = 1] = "COMMON_TEXT";
    /** 纯数字 2*/
    FIELD_TYPE[FIELD_TYPE["NUMBER"] = 2] = "NUMBER";
    /** 邮箱 3*/
    FIELD_TYPE[FIELD_TYPE["EMAIL"] = 3] = "EMAIL";
    /** 小写金额 4*/
    FIELD_TYPE[FIELD_TYPE["LOWER_CASE_AMOUNT"] = 4] = "LOWER_CASE_AMOUNT";
    /** 大写金额 5*/
    FIELD_TYPE[FIELD_TYPE["AMOUNT_IN_CAPITAL_LETTERS"] = 5] = "AMOUNT_IN_CAPITAL_LETTERS";
    /** 公司名称 6*/
    FIELD_TYPE[FIELD_TYPE["COMPANY_NAME"] = 6] = "COMPANY_NAME";
    /** 姓名 7*/
    FIELD_TYPE[FIELD_TYPE["NAME"] = 7] = "NAME";
    /** 银行 8*/
    FIELD_TYPE[FIELD_TYPE["BANK"] = 8] = "BANK";
    /** 地址 9*/
    FIELD_TYPE[FIELD_TYPE["ADDRESS"] = 9] = "ADDRESS";
    /** 数字/英文 10*/
    FIELD_TYPE[FIELD_TYPE["NUMBER_AND_ENGLISH"] = 10] = "NUMBER_AND_ENGLISH";
    /** 日期 11*/
    FIELD_TYPE[FIELD_TYPE["DATE"] = 11] = "DATE";
    /** 币种 12*/
    FIELD_TYPE[FIELD_TYPE["CURRENCY"] = 12] = "CURRENCY";
    /** 电话号码 13*/
    FIELD_TYPE[FIELD_TYPE["PHONE_NUMBER"] = 13] = "PHONE_NUMBER";
})(FIELD_TYPE || (FIELD_TYPE = {}));
/** 置信度 */
export var CONFIDENCE;
(function (CONFIDENCE) {
    /** 低 */
    CONFIDENCE[CONFIDENCE["LOW"] = 0.9] = "LOW";
    /** 中 */
    CONFIDENCE[CONFIDENCE["MIDDLE"] = 0.95] = "MIDDLE";
    /** 高 */
    CONFIDENCE[CONFIDENCE["HIGH"] = 1] = "HIGH";
})(CONFIDENCE || (CONFIDENCE = {}));
